import { BuyPlanPagePrismicDocument } from '../BuyPlanPagePrismicDocument'
import { logger } from '@dtx-company/logger'
import { prismicClient } from '@app/prismic/src/utils'
import useSWR, { SWRConfiguration, SWRResponse } from 'swr'

const fetchBuyPlanDocument = async (uid: string): Promise<BuyPlanPagePrismicDocument | null> => {
  try {
    const res = await prismicClient.getByUID<BuyPlanPagePrismicDocument>('buy_plan_page', uid)
    return res
  } catch (e) {
    logger.error({
      name: 'buy_plan_page',
      message: `buy_plan_page prismic doc not found for uid ${uid}`,
      team: 'monetization'
    })
  }
  return null
}

export function useBuyPlanPagePrismicDocumentSWR(
  uid: string | undefined,
  config?: SWRConfiguration<BuyPlanPagePrismicDocument | null>
): SWRResponse<BuyPlanPagePrismicDocument | null> {
  return useSWR<BuyPlanPagePrismicDocument | null>(
    uid ? ['buy_plan_page', uid] : null,
    ([_, uid]: [string, string]) => fetchBuyPlanDocument(uid),
    config
  )
}
